import { useEffect, useState } from "react"
import { getVisitaById, postVisita, patchVisita } from "../../services/VisitasServices"
import { VisitasFormContext } from "./VisitasContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Visitas } from '../../routes/RoutesConstants'

export const VisitasFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getVisitaByIdData(id)
    }, [])

    const getVisitaByIdData = async (id) => {
        let res = await getVisitaById(id)
        if (res) setReport(res)
    }

    const postVisitaData = async (body) => {
        const res = await postVisita(body)
        if (res) navigate("/visitas");
    }

    const patchVisitaData = async (id, body) => {
        const res = await patchVisita(id, body)

        if (res) navigate("/visitas");
    }


    return <VisitasFormContext.Provider value={{
        report,
        postVisitaData,
        patchVisitaData,
    }} >
        {children}
    </VisitasFormContext.Provider>
}